module.exports = __webpack_public_path__ + "img/supervision_640.23342e82.webp";